// useSession — the token seam the shell's authGuard (module 05) and query-callbacks consume
// (contract 06 §9). Token-only: `session.status`/RBAC belong to module 07. Reactive reads +
// the one-time `?handoff` exchange, which strips stale context, sets the bearer, and returns
// any account id for module 07 to switch into (delegation lands with the account barrel).
import { computed, type ComputedRef } from 'vue'

import { AuthLogoutFlow } from '../flows/AuthLogoutFlow'
import { AuthTokenHandoffFlow } from '../flows/AuthTokenHandoffFlow'
import type { TokenHandoffExchangeResponse } from '../models/auth.types'
import { useAuthStore } from '../stores/authStore'

export interface UseSession {
  token: ComputedRef<string | null>
  isAuthenticated: ComputedRef<boolean>
  redirectTarget: ComputedRef<string | null>
  getToken: () => string | null
  rememberTarget: (name: string | null) => void
  exchangeTokenHandoff: (handoff: string) => Promise<TokenHandoffExchangeResponse>
  logout: () => Promise<void>
  reset: () => void
}

export function useSession(): UseSession {
  const store = useAuthStore()

  return {
    token: computed(() => store.token),
    isAuthenticated: computed(() => store.isAuthenticated),
    redirectTarget: computed(() => store.redirectTarget),
    getToken: () => store.getToken(),
    rememberTarget: (name) => store.rememberTarget(name),
    exchangeTokenHandoff: (handoff) => new AuthTokenHandoffFlow({ store }).execute(handoff),
    logout: () => new AuthLogoutFlow().execute(),
    reset: () => store.reset(),
  }
}
